module.exports = new __parcel__URL__("vip.a2f7c3a9.svg").toString();